import { useCallback, useState } from 'react'

import { type FormikConfig } from 'formik'
import { useBoolean } from 'usehooks-ts'

import type { BidFormFormikValues } from '@/buyer-portal/components/features/listing/actions/auction/BidFormProvider'
import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

import { AuctionActionCellPostload } from './AuctionActionCellPostload'
import { AuctionActionCellPreload } from './AuctionActionCellPreload'

export const AuctionActionCell = ({
  searchListing,
}: {
  searchListing: CombinedListingSearchResult
}) => {
  const { setTrue: setCtaClicked, value: ctaClicked } = useBoolean(false)
  const [initialBidAmount, setInitialBidAmount] = useState<number>(0)

  const onSubmitPreload: FormikConfig<BidFormFormikValues>['onSubmit'] =
    useCallback(
      (values) => {
        setInitialBidAmount(values.amount || 0)
        setCtaClicked()
      },
      [setCtaClicked, setInitialBidAmount]
    )

  return ctaClicked ? (
    <AuctionActionCellPostload
      initialBidAmount={initialBidAmount}
      searchListing={searchListing}
    />
  ) : (
    <AuctionActionCellPreload
      onClickBuyNow={setCtaClicked}
      onSubmit={onSubmitPreload}
      searchListing={searchListing}
    />
  )
}
